import makeSlice from '@web/slices/gift/sliceMaker'

const slice = makeSlice()

export default slice.reducer
